import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Webcam02 = function Webcam02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M8 22h8m4.5-11.5c0 4.6944-3.8056 8.5-8.5 8.5s-8.5-3.8056-8.5-8.5S7.3056 2 12 2s8.5 3.8056 8.5 8.5m-5.3125 0c0 1.7604-1.4271 3.1875-3.1875 3.1875S8.8125 12.2604 8.8125 10.5 10.2396 7.3125 12 7.3125s3.1875 1.427 3.1875 3.1875"
    })
  }));
};
export default Webcam02;